import { Alert, Slide, styled } from "@mui/material"
import { useEffect } from "react";

export enum SnackbarType {
    DEFAULT = "info",
    SUCCESS = "success",
    ERROR = "error",
    WARNING = "warning",
}

export type SnackbarProps = {
    text: string;
    onClose: () => void;
    id: string;
    visible: boolean;
    type?: SnackbarType;
}

export const Snackbar = (props: SnackbarProps) => {
    const type = props.type || SnackbarType.DEFAULT;

    useEffect(() => {
        const timeout = setTimeout(props.onClose, 4000);

        return () => {
            clearTimeout(timeout);
        }
    }, []);

    return (
        <Slide
            direction="left"
            in={props.visible}
            mountOnEnter unmountOnExit
        >
            <Alert
                onClose={props.onClose}
                severity={type}
                sx={{ width: '100%' }}
            >
                {props.text}
            </Alert>
        </Slide>
    )
}

type SnackbarContainerProps = {
    snackbars: Omit<SnackbarProps, "onClose">[];
    onClose: (id: string) => void;
}

export const SnackbarContainer = ({ snackbars, onClose }: SnackbarContainerProps) => {
    return (
        <StyledSnackbarContainer>
            {snackbars.map((snackbar) => {
                return <Snackbar key={snackbar.id} {...snackbar} onClose={() => onClose(snackbar.id)} />
            })}
        </StyledSnackbarContainer>
    )
}

const StyledSnackbarContainer = styled(
    "div",
    {}
)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    maxHeight: "100vh",
    position: "fixed",
    top: 0,
    right: 0,
    overflowX: "hidden",
    overflowY: "auto",
    padding: theme.spacing(2),
    gap: theme.spacing(1),
    zIndex: theme.zIndex.drawer * 3,
}));